export const aboutData = {
  title: 'Who I am',
  description1:
    "My name is Ayush Kumar Shukla. I'm a Full-stack Developer based in India",
  description2:
    'I am a professional and passionate programmer in my daily life. A quick learner with a self-learning attitude. I love to learn and explore new technologies and am Passionate about Problem Solving. Love almost all the stacks of Software Engineering. My current stack includes **Node**, **React**, **Vue**, **NestJS**, **Typescript**, **Spring Boot** etc.',
  image: 1,
};
